<template>
    <div class="drive_div drive_div0">
        <div class="mapbox" id="mapbox"></div>
        <div class="driver_info" v-if="dealerInfo">
            <img class="img" :src="dealerInfo.images ? dealerInfo.images : require('../../assets/index/driver_img.jpg')" />
            <div class="title">经销商</div>
            <div class="name">{{ dealerInfo.dealerName }}</div>
            <div class="gps" @click="toGps()"></div>
        </div>
        <div class="form_box">
            <div class="form-item">
                <div class="label">姓名*</div>
                <div class="iptbox">
                    <input class="ipt iptname" placeholder="请输入姓名" v-model="form.cnname" maxlength="30" />
                </div>
                <div class="error"></div>
            </div>
            <div class="form-item">
                <div class="label">电话*</div>
                <div class="iptbox">
                    <input class="ipt ipttel" placeholder="请输入电话号码" v-model="form.mobile" maxlength="11" />
                </div>
                <div class="error"></div>
            </div>
            <div class="form-item">
                <div class="label">意向车型*</div>
                <div class="iptbox sltbox">
                    <select class="ipt iptcar" v-model="form.cartype" @change="onCarTypeChange">
                        <option value="">选择车型</option>
                        <option v-for="(item, idx) in carType" :key="idx" :value="item.value">{{ item.text }}</option>
                    </select>
                    <div class="arrow"></div>
                </div>
                <div class="error"></div>
            </div>
            <div class="form-item">
                <div class="checkbox" :class="{ checked: guo }" @click="toggleGuo()">
                    <span @click.stop="toXieyi()">接受 《隐私条款》 </span>
                </div>
            </div>
            <div class="form-footer">
                <div class="btn btntel" @click="toTel()" v-if="dealerInfo && dealerInfo.saleTel">一键咨询</div>
                <div class="btn btnsubmit" @click="submit()">预约试驾</div>
            </div>
        </div>
    </div>
</template>
<script>
import { sleep, isWeiXin, isIos, getQueryString, isPhoneNumber } from '../../utils/index'
import { post } from '../../utils/request'
export default {
    components: {},
    props: ['cartype'],
    data() {
        return {
            dealer_id: 0,
            activity_id: 0,
            dealerInfo: null,
            activityInfo: null,

            visibleYishi: false,
            topSize: 0,
            popCheXi: false,
            popXi: false,
            guo: false,
            carType: [
                { value: '165280', text: 'RS Q8 quattro 45周年纪念版' },
                { value: '165340', text: 'RS 6 Avant GT' }
            ],
            province: [],
            city: [],
            dealer: [],

            form: {
                epchannlkey: '033051b3edeb408a9b2bc0bfbb7bdbb9',
                channel: '',
                utm_source: '',
                campaign: '2025年Audi RS车型上市',
                carseries: '6640',
                carseries_text: 'RS',
                cartype: '',
                cartype_text: '',
                cnname: '',
                mobile: '',
                province: '',
                province_text: '',
                city: '',
                city_text: '',
                dealername: '',
                dealer_text: ''
            }
        }
    },
    created() {
        if (this.cartype) {
            this.form.cartype = this.cartype
            var find = this.carType.find((it) => {
                return it.value == this.cartype
            })
            if (find) {
                this.form.cartype_text = find.text
            }
        }
        this.dealer_id = getQueryString('dealer')
        this.activity_id = getQueryString('activity')
        this.getDealerInfo()
    },
    mounted() {
        var utm = getQueryString('utm')
        if (utm == '2502201931') {
            this.form.epchannlkey = 'f1d545681fc2419b99b39bf888f84d42'
            this.form.utm_source = '2502201931'
        } else if (utm == '2502201932') {
            this.form.epchannlkey = '6c128beacaa249b7a7adad09aac2c99a'
            this.form.utm_source = '2502201932'
        } else if (utm == '2502201934') {
            this.form.epchannlkey = 'f12af030f45d4e8fbcafec6413ef1b63'
            this.form.utm_source = '2502201934'
        }
        var channel = getQueryString('channel')
        if (!channel) channel = 1
        this.form.channel = channel

        this.bindEvents()
    },
    methods: {
        bindEvents() {
            $(window).scrollTop(0)
        },

        // 预约试驾---------------------------
        onCarTypeChange() {
            var it = this.carType.find((it) => {
                return it.value == this.form.cartype
            })
            if (it) {
                this.form.cartype_text = it.text
            } else {
                this.form.cartype_text = ''
            }
        },

        toggleGuo() {
            this.guo = !this.guo
        },
        toXieyi() {
            window.open('https://www.audi.cn/zh/privacy.html')
        },

        submit() {
            if (this.submitflag) return
            if (!this.form.cnname) {
                this.$alert('请填写您的姓名')
                return
            }
            if (!this.form.mobile) {
                this.$alert('请填写您的电话号码')
                return
            }
            if (!isPhoneNumber(this.form.mobile)) {
                this.$alert('电话号码格式错误')
                return
            }
            if (!this.form.cartype) {
                this.$alert('请选择车型')
                return
            }
            if (!this.form.province) {
                this.$alert('请选择省份')
                return
            }
            if (!this.form.city) {
                this.$alert('请选择城市')
                return
            }
            if (!this.form.dealername) {
                this.$alert('请选择经销商')
                return
            }
            if (!this.guo) {
                this.$alert('您还未同意隐私条款')
                return
            }
            this.submitData()
        },
        submitData() {
            this.submitflag = true
            var that = this
            var fm = new FormData()
            fm.append('epchannlkey', this.form.epchannlkey)
            fm.append('channel', this.form.channel)
            fm.append('utm_source', this.form.utm_source)
            fm.append('campaign', this.form.campaign)
            fm.append('carseries', this.form.carseries)
            fm.append('cartype', this.form.cartype)
            fm.append('cnname', this.form.cnname)
            fm.append('mobile', this.form.mobile)
            fm.append('province', this.form.province)
            fm.append('city', this.form.city)
            fm.append('dealername', this.form.dealername)

            window.startCaptcha(function (issuccess, captchaId) {
                if (!issuccess) {
                    that.submitflag = false
                    return
                }
                fm.append('captchaid', captchaId)
                that.saveStmClick(that.form)
                $.ajax({
                    type: 'POST',
                    url: 'https://contact.audi.cn/contact/student/testdrive/testdrive_addReleaseFtrueAppEP',
                    data: fm,
                    contentType: false,
                    processData: false,
                    success: function (res) {
                        if (res.success) {
                            that.$alert('提交成功', true)
                            that.clearForm()
                        } else {
                            that.$alert(res.message)
                        }
                    },
                    complete: function () {
                        that.submitflag = false
                    }
                })
            })
        },
        saveStmClick(data) {
            try {
                var name = data.cnname.substr(0, 1) + '**'
                var mobile = data.mobile.substr(0, 3) + '****' + data.mobile.substr(7, 4)
                stm_clicki('send', 'event', {
                    customActionId: 1,
                    customActionLabel1: data.cartype_text,
                    customActionLabel2: name,
                    customActionLabel3: mobile,
                    customActionLabel4: data.province_text,
                    customActionLabel5: data.city_text,
                    customActionLabel6: data.dealer_text,
                    customActionLabel7: 'RS页面',
                    customActionValue1: 1
                })
            } catch (e) {}
        },
        clearForm() {
            this.form.cartype = ''
            this.form.cartype_text = ''
            this.form.cnname = ''
            this.form.mobile = ''
            this.form.province = ''
            this.form.province_text = ''
            this.form.city = ''
            this.form.city_text = ''
            this.form.dealername = ''
            this.form.dealer_text = ''
            this.guo = false
        },
        async getDealerInfo() {
            var res = await post('/web/dealerInfo.json', { dealer_id: this.dealer_id, activity_id: this.activity_id })
            console.log(res)
            this.dealerInfo = res.dealer
            this.activityInfo = res.activity
            var share = res.share

            this.form.province_text = this.dealerInfo.province
            this.form.city_text = this.dealerInfo.city
            this.form.dealer_text = this.dealerInfo.dealerName
            for (var k in dprovinces) {
                var v = dprovinces[k][1]
                if (v.indexOf(this.dealerInfo.province) >= 0) {
                    this.form.province = dprovinces[k][0]
                    break
                }
            }
            for (var k in dcitys) {
                var cs = dcitys[k]
                for (var k in cs) {
                    var v = cs[k][1]
                    if (v.indexOf(this.dealerInfo.city) >= 0) {
                        this.form.city = cs[k][0]
                        break
                    }
                }
            }
            for (var k in dealers) {
                var cs = dealers[k]
                for (var k in cs) {
                    var v = cs[k][1]
                    if (v.indexOf(this.dealerInfo.dealerName) >= 0) {
                        this.form.dealername = cs[k][0]
                        break
                    }
                }
            }
            console.log(this.form)
            this.initMap()
            if (typeof setShareDefault != 'undefined') {
                setShareDefault(share.shareTitle, share.shareDesc, 'https://contact.audi.cn' + share.shareImage, share.dealerId, share.activityId)
            }
        },

        toTel() {
            if (this.dealerInfo && this.dealerInfo.saleTel) {
                window.location.href = 'tel:' + this.dealerInfo.saleTel
            }
        },
        async initMap() {
            var hasLng = false
            var lng = 116.400819
            var lat = 39.913385
            if (this.dealerInfo.lng && this.dealerInfo.lat) {
                hasLng = true
                lng = this.dealerInfo.lng
                lat = this.dealerInfo.lat
            }
            var map = new BMap.Map('mapbox')
            var point = new BMap.Point(lng, lat)
            map.centerAndZoom(point, 16)
            var opts = { anchor: BMAP_ANCHOR_BOTTOM_LEFT }
            map.addControl(new BMap.NavigationControl(opts))
            if (!hasLng) return

            // 定义自定义覆盖物的构造函数
            function SquareOverlay(center, length, color) {
                this._center = center
                this._length = length
                this._color = color
            }
            // 继承API的BMap.Overlay
            SquareOverlay.prototype = new BMap.Overlay()
            // 实现初始化方法
            SquareOverlay.prototype.initialize = function (map) {
                // 保存map对象实例
                this._map = map
                // 创建div元素，作为自定义覆盖物的容器
                var div = document.createElement('div')
                div.style.position = 'absolute'
                // 可以根据参数设置元素外观
                div.style.width = this._length + 'px'
                div.style.height = this._length + 'px'
                div.style.background = this._color
                div.style.backgroundSize = '100% 100%'
                // 将div添加到覆盖物容器中
                map.getPanes().markerPane.appendChild(div)
                // 保存div实例
                this._div = div
                // 需要将div元素作为方法的返回值，当调用该覆盖物的show、
                // hide方法，或者对覆盖物进行移除时，API都将操作此元素。
                return div
            }
            // 实现绘制方法
            SquareOverlay.prototype.draw = function () {
                // 根据地理坐标转换为像素坐标，并设置给容器
                var position = this._map.pointToOverlayPixel(this._center)
                this._div.style.left = position.x - this._length / 2 + 'px'
                this._div.style.top = position.y - this._length + 'px'
            }
            // 实现显示方法
            SquareOverlay.prototype.show = function () {
                if (this._div) {
                    this._div.style.display = ''
                }
            }
            // 实现隐藏方法
            SquareOverlay.prototype.hide = function () {
                if (this._div) {
                    this._div.style.display = 'none'
                }
            }
            // 添加自定义方法
            SquareOverlay.prototype.toggle = function () {
                if (this._div) {
                    if (this._div.style.display == '') {
                        this.hide()
                    } else {
                        this.show()
                    }
                }
            }
            // 添加自定义覆盖物
            var mySquare = new SquareOverlay(map.getCenter(), 100, 'url(https://contact.audi.cn/dealers/static/imgs/pc/point.png) no-repeat center center')
            map.addOverlay(mySquare)

            var that = this
            var geolocation = new BMap.Geolocation()
            geolocation.getCurrentPosition(function (r) {
                console.log(r)
                if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                    that.currGps = {
                        address: r.address,
                        lng: r.point.lng,
                        lat: r.point.lat
                    }
                    console.log(that.currGps)
                } else {
                    console.log('failed' + this.getStatus())
                }
            })
        },
        toGps() {
            var mylng = this.currGps.lat + ',' + this.currGps.lng
            var tarlng = this.dealerInfo.lat + ',' + this.dealerInfo.lng
            var name = this.dealerInfo.dealerName
            var province = this.dealerInfo.province
            var url = 'https://api.map.baidu.com/direction?origin=latlng:' + mylng + '|name:我的位置&destination=latlng:' + tarlng + '|name:' + name + '&mode=driving&region=' + province + '&output=html&src=Audi'
            console.log(url)
            window.open(url)
        }
    },
    beforeDestroy() {
        TweenMax.killTweensOf('*')
        console.log('清除动画')
    }
}
</script>
<style scoped lang="scss">
.drive_div0 {
    width: 100%;
    height: 583px;
    position: absolute;
    z-index: 3;
    background-color: rgba(0, 0, 0, 0.85);
    left: 0;
    bottom: 0;
    .mapbox {
        width: 1019px;
        height: 456px;
        position: absolute;
        left: 108px;
        top: 65px;
        overflow: hidden;
        background-color: #fff;
    }
    .driver_info {
        box-sizing: border-box;
        padding: 30px 20px;
        width: 310px;
        min-height: 355px;
        position: absolute;
        left: 902px;
        top: 142px;
        overflow: hidden;
        z-index: 3;
        background-color: #000;
        .img {
            width: 270px;
            height: 150px;
            left: 20px;
            top: 30px;
            display: block;
            object-fit: cover;
        }
        .title {
            font-size: 18px;
            line-height: 22px;
            margin-top: 24px;
        }
        .name {
            font-size: 18px;
            line-height: 22px;
            margin-top: 20px;
        }
        .gps {
            width: 32px;
            height: 32px;
            background: url(../../assets/index/page2_gps.svg) no-repeat center center;
            background-size: contain;
            margin-top: 20px;
            cursor: pointer;
        }
    }
    .form_box {
        width: 448px;
        position: absolute;
        left: 1326px;
        top: 52px;
        .ipt {
            font-size: 18px;
            line-height: 35px;
            margin-top: 10px;
            position: relative;
            option {
                background-color: rgba(0, 0, 0, 0.8);
                color: #fff;
                font-size: 18px;
            }
        }
        .form-item {
            position: relative;
            padding-top: 10px;
            .iptbox {
                border-bottom: 1px solid #383838;
                position: relative;
                &.sltbox {
                    padding-right: 20px;
                }
            }
            .label {
                font-size: 18px;
                line-height: 22px;
            }
            .error {
                height: 25px;
                font-size: 12px;
                line-height: 22px;
                color: #d20630;
                padding-top: 5px;
            }
            .arrow {
                display: block;
                width: 12px;
                height: 12px;
                background: url(../../assets/index/page2_arrow.svg) no-repeat center center;
                background-size: contain;
                position: absolute;
                z-index: 2;
                right: 5px;
                top: 24px;
            }
            .iptcar {
                font-size: 24px;
                font-family: 'audi_extended_bold_4.03';
            }
            .checkbox {
                height: 26px;
                background: url(../../assets/index/page2_echeck.svg) no-repeat left center;
                background-size: contain;
                font-size: 18px;
                line-height: 26px;
                padding-left: 34px;
                position: relative;
                cursor: pointer;
                &.checked {
                    &::before {
                        content: ' ';
                        height: 30px;
                        width: 30px;
                        background: url(../../assets/index/page2_echeck_on.svg) no-repeat left center;
                        background-size: contain;
                        position: absolute;
                        left: -2px;
                        top: -4px;
                        z-index: 2;
                    }
                }
            }
        }
        .form-footer {
            padding-top: 30px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            .btn {
                width: 224px;
                height: 53px;
                cursor: pointer;
                font-size: 18px;
                line-height: 53px;
                text-align: center;
                background: url(../../assets/index/page2_btn1.png) no-repeat center center;
                background-size: contain;
                &:hover {
                    background: url(../../assets/index/page2_btn2.png) no-repeat center center;
                    background-size: contain;
                }
            }
        }
    }
}
</style>
